import React from 'react';
import { createRoot } from 'react-dom/client'; // React 18+
import App from './App';
import WhatsAppButton from '../src/components/WhatsAppButton/index'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import store from './utils/Redux/Store/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const queryClient = new QueryClient(); // **create instance once**

const persistor = persistStore(store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}> {/* <-- pass client here */}
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <App />
          {/* Floating WhatsApp Button */}
      <WhatsAppButton />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

// ReactDOM.render(
//   <QueryClientProvider client={queryClient} >
//     <Provider store={store}>
//       <PersistGate persistor={persistor}>
//         <App />
//       </PersistGate>
//     </Provider>
//     {/* <ReactQueryDevtools /> */}
//   </QueryClientProvider>,
//   document.getElementById('root')
// );

